module.exports = __webpack_public_path__ + "img/onlineToolsImg2.1ed4d1ab.png";